import * as fmt from "lib/fmt"

/* eslint-disable */
export const Info = console.log.bind(console)
export const Debug = console.debug.bind(console)
export const Warn = console.warn.bind(console)

export function Fatal(...args: any[]): never {
	throw new Error(fmt.Sprint(...args))
}

export function Fatalf(format: string, ...args: any[]): never {
	throw new Error(fmt.Sprintf(format, ...args))
}

export function Infof(format: string, ...args: any[]): void {
	console.log(fmt.Sprintf(format, ...args))
}

export function Errorf(format: string, ...args: any[]): void {
	console.error(fmt.Sprintf(format, ...args))
}
